.title {
  color: rgb(var(--ng-neutral-60));
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
